// Latvian cardinal numbers (feminine form, used with daļa)
export const LATVIAN_NUMERATORS = {
  1:  'viena',
  2:  'divas',
  3:  'trīs',
  4:  'četras',
  5:  'piecas',
  6:  'sešas',
  7:  'septiņas',
  8:  'astoņas',
  9:  'deviņas',
  10: 'desmit',
};

// [singular (with viena), plural (with 2+)]
export const LATVIAN_DENOMINATORS = {
  3:  ['trešdaļa',        'trešdaļas'],
  4:  ['ceturtdaļa',      'ceturtdaļas'],
  5:  ['piektdaļa',       'piektdaļas'],
  6:  ['sestdaļa',        'sestdaļas'],
  7:  ['septītdaļa',      'septītdaļas'],
  8:  ['astotdaļa',       'astotdaļas'],
  9:  ['devītdaļa',       'devītdaļas'],
  10: ['desmitdaļa',      'desmitdaļas'],
  12: ['divpadsmitdaļa',  'divpadsmitdaļas'],
};

export function buildLatvianPhrase(num, den) {
  const numWord = LATVIAN_NUMERATORS[num];
  const [singular, plural] = LATVIAN_DENOMINATORS[den];
  const denWord = num === 1 ? singular : plural;
  return `${numWord} ${denWord}`;
}
